<template>
  <div class="page-class">
    <LayerActivateResult v-model="layerStatus" type="error" @sure="retry" :desc="errorDesc"></LayerActivateResult>
  </div>
</template>
<script>
import storeMixin from '../mixins/store'
import activateMixin from './activate-mixin'
import queryString from '@spero/spero-utils/src/helpers/queryString'
import {ZSLD_CONFIG} from './config'
import session from '@spero/spero-utils/src/helpers/session'
import STORAGE from '@spero/spero-utils/src/constants/STORAGE'
import LayerActivateResult from './components/layer-activate-result'
import csMixins from './cs-mixins'

import axios from 'axios'
export default {
  name: '',
  props: ['classId'],
  mixins: [storeMixin, activateMixin, csMixins],
  components: {LayerActivateResult},
  data () {
    return {
      zsldToken: '',
      layerStatus: false,
      errorDesc: '',
      fwToken: ''
    }
  },
  methods: {
    async anonymityLogin () {
      const {data: {token}} = await this.$rootApi.login.anonymityLogin()
      session.set(STORAGE.LOGIN_TOKEN, token)
    },
    async init () {
      let {search = '?', hash} = location
      const fi1 = hash.indexOf('?')
      const fi2 = hash.indexOf('&')

      const fi = fi1 > -1 ? fi1 : fi2 > -1 ? fi2 : -1
      const m = '&' + (fi > -1 ? hash.slice(fi + 1) : '')

      this.fwToken = queryString.query(`${search}${m}`).fwWechatToken
      const token = session.get('ZSLD_TOKEN')
      // 无fwWechatToken则进行授权
      const {authHost, appId} = ZSLD_CONFIG
      if (!this.fwToken && !token) {
        const rb = encodeURIComponent(location.href)
        location.replace(`${authHost}/auth/active?appId=${appId}&returnUrl=${rb}`)
        return
      }
      await this.anonymityLogin()
      if (!token) {
        await this.getZsldToken()
      } else {
        session.set(STORAGE.LOGIN_TOKEN, token)
        this.classActivete()
      }
    },
    async getZsldToken () {
      try {
        const {fwToken} = this
        const {zscsHost, appId} = ZSLD_CONFIG
        /*
        * fwToken: this.fwToken,
        wechatAppId: this.appid,
        * */
        const api = `${zscsHost}/api/v1/auth/getToken2`
        const res = await axios.get(queryString.addKey(api, {fwToken, wechatAppId: appId}))
        const {data: {code, result, message}} = res
        if (code === 0) {
          this.zsldToken = result.token
          this.zsldLogin()
        } else {
          throw message
        }
      } catch (e) {
        this.SET_PHONE_LOGIN({type: 'login'})
        this.$toast(e.message || e)
      }
    },
    async zsldLogin () {
      try {
        let {data: {data: {token}, code, message}} = await this.$rootApi.api(['zsldLogin'], {
          data: {
            jinceToken: this.zsldToken,
            distinctId: 'SPERO_APP_H5_DISTINCT_ID'
          }
        })
        if (code === 0) {
          session.set(STORAGE.LOGIN_TOKEN, token)
          session.set('ZSLD_TOKEN', token)
          await this.updateUserInfo()
          if (this.isWechat && !this.USERINFO.isTourist) {
            this.checkCenterUserInfo()
          }
          this.classActivete()
        } else {
          throw message
        }
      } catch (e) {
        this.$toast(e.message || e)
      }
    },
    async updateUserInfo () {
      const {data: {code, data, message}} = await this.$rootApi.api(['pureUserInfo'])
      if (code === 0) {
        this.SET_USERINFO(data)
      } else {
        throw message
      }
    },
    classActivete () {
      this.activate({classId: this.classId}, (params, resp) => {
        if (params.type === 'error') {
          // this.$toast('无可用订单')
          //
          if (params.message === 'NOCLASS') return
          this.errorDesc = params.message
          this.layerStatus = true
          return
        }
        this.$router.replace({
          name: 'course',
          params: {
            id: resp.courseId
          },
          query: {
            activate: 1
          }
        })
      })
    },
    retry () {
      this.layerStatus = false
      this.classActivete()
    }
  },
  watch: {
    loginCount: {
      handler: function (v) {
        if (v > 1) {
          if (this.isWechat && !this.USERINFO.isTourist) {
            this.checkCenterUserInfo()
          }
          this.classActivete()
        }
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
  }
}
</script>
<style lang="stylus" type="text/stylus" scoped>

</style>
